import { useRef, useState } from "react";
import * as nodeUtils from "../../../../abstract/controller/utils/nodeUtils";
import * as uuidUtils from "../../../../abstract/controller/utils/uuidUtils";
import ChildrenChoice from "../ChildrenChoice";
import ChildrenParameter from "../ChildrenParameter";
import ChildrenUndefined from "../ChildrenUndefined";
import ParameterConditions from "../ParameterConditions";
import ParameterContainer from "../ParameterContainer";
import ParameterHeader from "../ParameterHeader";
import ParameterMain from "../ParameterMain";
import ParameterOptions from "../ParameterOptions";
import ParameterPanel from "../ParameterPanel";
import ReadOnlyParameterContainer from "../ReadOnlyParameterContainer";
import ReadOnlyParameterHeader from "../ReadOnlyParameterHeader";
import ReadOnlyParameterMain from "../ReadOnlyParameterMain";
import ReadOnlyParameterPanel from "../ReadOnlyParameterPanel";
import styles from "./ParameterStructure.module.scss";

function ParameterStructure({ node, position, readOnly }) {
  const _id = nodeUtils.getID(node.current);
  const _uuid = useRef(readOnly ? `?${uuidUtils.createUuid()}` : "");
  const _idParsed = `${_id}${_uuid.current}`;

  return (
    <div className={styles["structure"]}>
      {readOnly ? (
        <StructureImmutable id={_idParsed} node={node} />
      ) : (
        <StructureMutable id={_idParsed} node={node} position={position} />
      )}
    </div>
  );
}

function StructureImmutable({ id, node }) {
  const [_isFolded, _setIsFolded] = useState(false);

  return (
    <ReadOnlyParameterContainer isFolded={_isFolded}>
      <ReadOnlyParameterPanel />
      <ReadOnlyParameterMain node={node} isFolded={_isFolded} setIsFolded={_setIsFolded}>
        <ReadOnlyParameterHeader
          id={id}
          node={node.current}
          isFolded={_isFolded}
          setIsFolded={_setIsFolded}
        />
        <ParameterChildren node={node.current} readOnly={true} />
      </ReadOnlyParameterMain>
    </ReadOnlyParameterContainer>
  );
}

function StructureMutable({ id, node, position }) {
  const iconRight = position.isNested || !position.isLast;
  const panelRight = position.isNested && (position.isOneBeforeLast || position.isLast);

  return (
    <ParameterContainer node={node.current}>
      <ParameterPanel node={node} position={position} primary />
      <ParameterMain node={node} iconRight={iconRight}>
        <ParameterHeader id={id} node={node.current} />
        <ParameterChildren node={node.current} readOnly={false} />
        <ParameterConditions node={node.current} />
        <ParameterOptions node={node.current} />
      </ParameterMain>

      {panelRight && (
        <ParameterPanel node={node} position={position} secondary />
      )}
    </ParameterContainer>
  );
}

function ParameterChildren({ node, readOnly }) {
  return (
    <>
      <ChildrenChoice node={node} readOnly={readOnly} />
      <ChildrenParameter node={node} readOnly={readOnly} />
      <ChildrenUndefined node={node} readOnly={readOnly} />
    </>
  );
}

export default ParameterStructure;
